module.exports = __webpack_public_path__ + "static/media/requestrr_black.40c97a68.svg";